import { IOrderBump, IPlan } from "@components/pages/product/Offers/crud/forms/CreateOfferForm/CreateOfferForm.types";
import { CheckoutConfigConstants } from "./ICheckout";

export namespace OfferConstants {
  export enum BillingType {
    ONE_TIME = "ONE_TIME",
    RECURRING = "RECURRING",
  }

  export const BillingTypeTranslations = {
    [BillingType.ONE_TIME]: "Preço Único",
    [BillingType.RECURRING]: "Assinatura",
  };

  export enum Status {
    INACTIVE = "INACTIVE",
    ACTIVE = "ACTIVE",
  }

  export const StatusOptions = [
    { value: Status.ACTIVE, label: "Ativo" },
    { value: Status.INACTIVE, label: "Inativo" },
  ];

  export enum ChargeFrequency {
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
    SEMIANNUALLY = "SEMIANNUALLY",
    ANNUALLY = "ANNUALLY",
  }

  export const ChargeFrequencyTranslate = {
    [ChargeFrequency.ANNUALLY]: "Anual",
    [ChargeFrequency.MONTHLY]: "Mensal",
    [ChargeFrequency.SEMIANNUALLY]: "Semestral",
    [ChargeFrequency.QUARTERLY]: "Trimestral",
    [ChargeFrequency.WEEKLY]: "Semanal",
  };

  export const ChargeFrequencyInstallmentsAlert = {
    [ChargeFrequency.ANNUALLY]: "Por conta da frequência, o limite de parcelamento é de 12x.",
    [ChargeFrequency.MONTHLY]: "Por conta da frequência, o limite de parcelamento é de 1x.",
    [ChargeFrequency.SEMIANNUALLY]: "Por conta da frequência, o limite de parcelamento é de 6x.",
    [ChargeFrequency.QUARTERLY]: "Por conta da frequência, o limite de parcelamento é de 3x.",
    [ChargeFrequency.WEEKLY]: "Por conta da frequência, o limite de parcelamento é de 1x.",
  };

  export const ChargeFrequencyOptions = [
    { value: ChargeFrequency.ANNUALLY, label: ChargeFrequencyTranslate[ChargeFrequency.ANNUALLY] },
    { value: ChargeFrequency.SEMIANNUALLY, label: ChargeFrequencyTranslate[ChargeFrequency.SEMIANNUALLY] },
    { value: ChargeFrequency.QUARTERLY, label: ChargeFrequencyTranslate[ChargeFrequency.QUARTERLY] },
    { value: ChargeFrequency.MONTHLY, label: ChargeFrequencyTranslate[ChargeFrequency.MONTHLY] },
    { value: ChargeFrequency.WEEKLY, label: ChargeFrequencyTranslate[ChargeFrequency.WEEKLY] },
  ];

  export enum Tags {
    NONE = "Nenhum",
    NEW = "Novidade",
    SPECIAL_PRICE = "Preço Especial",
    RECOMMENDED = "Recomendado",
    OFFER = "Oferta",
    DISCOUNT = "Desconto",
    EXTRA = "Extra",
    RELEASE = "Lançamento",
    ADVANTAGE = "Vantagem",
    BONUS = "Bônus",
  }

  export const PlansTagsTranslate = {
    [Tags.NONE]: "Nenhum",
    [Tags.NEW]: "Novidade",
    [Tags.SPECIAL_PRICE]: "Preço Especial",
    [Tags.RECOMMENDED]: "Recomendado",
    [Tags.OFFER]: "Oferta",
    [Tags.DISCOUNT]: "Desconto",
    [Tags.EXTRA]: "Extra",
    [Tags.RELEASE]: "Lançamento",
    [Tags.ADVANTAGE]: "Vantagem",
    [Tags.BONUS]: "Bônus",
  };

  export const PlansTagsOptions = [
    { value: Tags.NONE, label: PlansTagsTranslate[Tags.NONE] },
    { value: Tags.RECOMMENDED, label: PlansTagsTranslate[Tags.RECOMMENDED] },
    { value: Tags.NEW, label: PlansTagsTranslate[Tags.NEW] },
    { value: Tags.SPECIAL_PRICE, label: PlansTagsTranslate[Tags.SPECIAL_PRICE] },
    { value: Tags.OFFER, label: PlansTagsTranslate[Tags.OFFER] },
    { value: Tags.DISCOUNT, label: PlansTagsTranslate[Tags.DISCOUNT] },
    { value: Tags.EXTRA, label: PlansTagsTranslate[Tags.EXTRA] },
    { value: Tags.RELEASE, label: PlansTagsTranslate[Tags.RELEASE] },
    { value: Tags.ADVANTAGE, label: PlansTagsTranslate[Tags.ADVANTAGE] },
    { value: Tags.BONUS, label: PlansTagsTranslate[Tags.BONUS] },
  ];
}
export interface CreateOrUpdateOfferRequest {
  uuid?: string | null;
  productUuid: string;
  checkoutConfigUuid?: string;
  billingType?: OfferConstants.BillingType;
  status?: OfferConstants.Status;
  name?: string;
  isFree?: boolean;
  price?: number;
  orderBumps?: string[] | IOrderBump[];
  customPageUrl?: string | null;
  customPageUrlEnabled?: boolean;
  backRedirectUrl?: string | null;
  backRedirectUrlEnabled?: boolean;
  orderBumpsEnabled?: boolean;
  plans?: IPlan[];
}
export interface UpdateOfferType {
  productUuid: string;
  uuid?: string;
  checkoutConfigUuid?: string;
  billingType?: OfferConstants.BillingType;
  status?: OfferConstants.Status;
  name?: string;
  isFree?: boolean;
  price?: number;
  customPageUrl?: string | null;
  customPageUrlEnabled?: boolean;
  backRedirectUrl?: string | null;
  backRedirectUrlEnabled?: boolean;
  orderBumps?: string[];
  plans?: IPlan[];
}

export interface ListOffersResponseType {
  meta: {
    page: number;
    pages: number;
    pageSize: number;
    total: number;
  };
  data: ListOffersType[];
}

export interface PlanListType {
  chargeFrequency: OfferConstants.ChargeFrequency;
  price: number;
  promotionalPrice: number;
  commission: number;
}

export interface ListOffersType {
  uuid: string;
  productUuid: string;
  checkoutConfig: {
    uuid: string;
    name?: string;
    backgroundColor: CheckoutConfigConstants.BackgroundType;
    colorPrimary: string;
    colorSecondary: string;
  };
  name: string;
  isFree: boolean;
  price: number;
  commissionRate: number;
  commission: number;
  billingType: OfferConstants.BillingType;
  status: OfferConstants.Status;
  customPageUrl?: string | null;
  customPageUrlEnabled: boolean;
  backRedirectUrl: string | null;
  backRedirectUrlEnabled: boolean;
  checkoutUrl: string;
  orderBumps: string[];
  orderBumpsEnabled: boolean;
  plans: Array<PlanListType>;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}

type OrderBumpType = {
  uuid: string;
  name: string;
  price: number;
  billingType: OfferConstants.BillingType;
  productName: string;
  productPhoto?: string | null;
  order: number;
};

type PlanType = {
  uuid?: string;
  title: string;
  tag: OfferConstants.Tags;
  price: number;
  promotionalPrice?: number;
  firstChargePriceEnabled: boolean;
  firstChargePrice?: number;
  fixedChargesEnabled: boolean;
  fixedCharges?: number;
  chargeFrequency: OfferConstants.ChargeFrequency;
  isDefault: boolean;
  hasSubscription: boolean;
};
export interface ShowOfferType {
  uuid: string;
  productUuid: string;
  checkoutConfigUuid: string;
  checkoutConfig: { uuid: string; name?: string };
  name: string;
  isFree?: boolean;
  price: number;
  billingType: OfferConstants.BillingType;
  status: OfferConstants.Status;
  checkoutUrl: string;
  customPageUrl?: string | null;
  customPageUrlEnabled?: boolean;
  backRedirectUrl?: string | null;
  backRedirectUrlEnabled?: boolean;
  orderBumpsEnabled: boolean;
  orderBumps?: OrderBumpType[];
  plans?: PlanType[];
  createdAt?: Date | null;
  updatedAt?: Date | null;
}

export interface FetchOffersType {
  productUuid: string;
  params?: {
    search?: string;
    page?: number;
    pageSize?: number;
  };
}

export type DefaultOrderBumpType = {
  uuid: string;
  name: string;
  price: number;
  billingType: OfferConstants.BillingType;
  productName: string;
  productPhoto?: string | null;
};

export type DefaultPlanType = {
  uuid?: string;
  title: string;
  tag: OfferConstants.Tags | null;
  price: string;
  promotionalPrice: string;
  firstChargePriceEnabled: boolean;
  firstChargePrice?: string;
  fixedChargesEnabled: boolean;
  fixedCharges?: string;
  chargeFrequency: OfferConstants.ChargeFrequency;
  isDefault: boolean;
};

export interface DefaultOfferType {
  productUuid?: string;
  uuid?: string;
  billingType?: OfferConstants.BillingType;
  status?: boolean;
  name?: string;
  checkoutConfigUuid?: string;

  isFree?: boolean;
  price?: string;

  orderBumps?: DefaultOrderBumpType[];
  orderBumpsEnabled: boolean;
  plans?: DefaultPlanType[];

  customPageUrlEnabled?: boolean;
  customPageUrl?: string | null;

  backRedirectUrlEnabled?: boolean;
  backRedirectUrl?: string | null;

  hasSubscription?: boolean;
  submitType?: "create" | "update";
}
